// extracted by mini-css-extract-plugin
export default {"power":"OurAIView_power__2T1pS"};